/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Permissions_Create_PermissionInputs */

const en_admin_permissions_create_permission = /** @type {(inputs: Admin_Permissions_Create_PermissionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Create Permission`)
};

/**
* | output |
* | --- |
* | "Create Permission" |
*
* @param {Admin_Permissions_Create_PermissionInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const admin_permissions_create_permission = /** @type {((inputs?: Admin_Permissions_Create_PermissionInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Permissions_Create_PermissionInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_admin_permissions_create_permission(inputs)
});
export { admin_permissions_create_permission as "admin.permissions.create_permission" }